<template>
	<search :privateRoute="privateRoute" key="discover-view" />
</template>

<script>
import Search from '../../../components/Search/SearchHomeComponent.vue'

export default {
	components: { Search },
	name: 'discover-view',
	computed: {
		privateRoute() {
			return this.$route.meta && !this.$route.meta.guest
		}
	},

	mounted() {
		if (window.HubSpotConversations) {
			window.HubSpotConversations.widget.refresh()
		}
		this.setNav({
			showNavHeader: false
		})
	}
}
</script>

<style lang="scss" scoped></style>
